import { API, Auth } from 'aws-amplify';
import * as _ from 'lodash';

import {
    FETCH_ACTIVITIES,
    FETCH_ACTIVITIES_SUCCESS,
    FETCH_ACTIVITIES_ERROR,
    FETCH_ANALYTICS_DATA_SUCCESS,
} from '../actions/types'

// export const fetchConfigs = () => {
//     return async (dispatch) => {
//         const configs = await API.get('OnaCorpAPI', `/configs`) 
//     }
// }

export const getActivities = (companyId) => {
    return async (dispatch) => {
        dispatch({ type: FETCH_ACTIVITIES })
        let config = {
            headers: {
                Authorization: _.get((await Auth.currentSession()), 'idToken.jwtToken', null),
            },
            queryStringParameters: { companyId }
        };
        try {
            const response = await API.get('LogsAPI', '/activities', config)
            if (response.success) {
                dispatch({ type: FETCH_ACTIVITIES_SUCCESS, payload: { activities: response.activities } })
            } else {
                throw new Error("Internal server error")
            }
        } catch (error) {
            console.log(error)
            dispatch({ type: FETCH_ACTIVITIES_ERROR })
        }
    }
}

export const getAnalyticsData = (companyId = null) => {
    return async (dispatch) => {
        let config = {
            headers: {
                Authorization: _.get((await Auth.currentSession()), 'idToken.jwtToken', null),
            },
            queryStringParameters: { companyId }
        };
        try {
            const response = await API.get('TasksAPI', `/tasks/analytics`, config)
            if (response.success) {
                dispatch({ type: FETCH_ANALYTICS_DATA_SUCCESS, payload: { anaylticData: response.data } })
            } else {
                throw new Error("Internal server error")
            }
        } catch (error) {
            console.log(error)
            dispatch({ type: FETCH_ACTIVITIES_ERROR })
        }
    }
}